export default __webpack_public_path__ + "static/media/36I-114289_-21014_0.e684e38c.jpg";